import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";


export interface IDropdownToggle {
  id?:string;
  className?: string;
  children?: ReactNode;
  files?: [
    {
      id: number;
      title: string;
      comment: string;
    }
  ];
  currentId?: string;
  onChange?: (selectedId: string | null, currentId: string | null) => void;
  onClick?: () => void;
}

function DropdownToggle({
  files,
  id,
  currentId,
  className,
  onClick,
  children,
}: IDropdownToggle) {
  const activeFile = files?.find((file) => file.id.toString() === currentId);
  const getFileTitle = ({
    title,
    comment,
  }: {
    title: string;
    comment: string;
  }) => comment || title;
  return (

    <button id={id} type="button" className={className} onClick={onClick}>
      {children || (
        <>
          <span className="pr-2">
            {activeFile ? getFileTitle(activeFile) : "انتخاب کنید..."}
          </span>
          <FontAwesomeIcon
            icon="caret-down"
            size="lg"
            className="text-secondary"
          />
        </>
      )}
    </button>
  );
}
export default DropdownToggle;
